<!--
 * @Description: 
 * @Author: pcc
 * @Date: 2022-11-02 17:20:32
 * @LastEditors: zml
 * @LastEditTime: 2025-08-15 17:01:33
-->
<template>
  <div class="order">
    <div class="container">
      <div class="myOrderTile">{{ $hs("我的订单","My Order","") }}</div>
      <div class="order-container">
        <div class="order-list" v-if="orderList.length>0">
          <div class="order_listBox">
            <div class="order_list_items" v-for="(item, index) in orderList" :key="index">
              <div class="order_numer">
                {{ $hs('订单编号', 'Order Number','Número de pedido') }}:
                <span>{{ item.orderNo }}</span>
              </div>
              <div class="order_Time">
                <span class="Time_TitleName">{{$hs('订单时间', 'Order Time','Hora del pedido')}}:</span>
                <span class="Time_Title">{{ item.createdTime }}</span>
              </div>
              <div class="order_contactPerson">
                <span class="contactPerson_Title">{{$hs('联系人', 'Contact Person','contacto')}}:</span>
                <span class="contactPerson_Name">{{ item.createdUserName }}</span>
              </div>
              <div class="order_emai">
                <span class="emai_title">{{$hs('电子邮箱', 'Emai','Correo electrónico')}}:</span>
                <span class="emai_number">{{ item.createdUserEmail }}</span>
              </div>
              <div
                class="orderDetails"
                @click="$router.push({ path: '/order/detail', query: { orderNo: item.orderNo } })"
              >{{$hs('查看详情', 'Order Details','Ver los detalles')}}</div>
            </div>
          </div>

          <!-- <order-box v-for="(item, index) in orderList" :orderInfo="item" :key="index"></order-box> -->

          <div class="pagination">
            <el-pagination
              background
              :current-page="queryParam.pageNo"
              :page-size="8"
              :total="totalRows"
              layout="prev, pager, next, jumper, total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
        <el-empty description="暂时无数据" v-else></el-empty>
      </div>
      <!-- <div class="exclusive" v-if="productList.length > 0">
        <div class="title">{{$t('LLH.exclusive')}}</div>
        <div class="pro-list">
          <div class="cell" v-for="(item,index) in productList" :key="index">
            <everyProduct :productData="item"></everyProduct>
          </div>
        </div>
        <div class="pagination" v-if="productList.length > 0">
          <el-pagination
            @size-change="handleProSizeChange"
            @current-change="handleProCurrentChange"
            :page-size="10"
            layout="prev, pager, next, jumper, total"
            :total="totalProRows"
          ></el-pagination>
        </div>
      </div>-->
    </div>
  </div>
</template>
<script>
import { getOrderList } from '@/api/order'
import { getSellRecPorductList } from '@/api/product'
import { GetMemberInfo } from '@/api/login'
import everyProduct from '@/components/productBox/everyProduct.vue' //单个产品组件
import { mapGetters } from 'vuex'
import transformMark from '@/utils/water'
import orderBox from './orderBox.vue'
export default {
  name: 'pageOrder',
  components: {
    orderBox,
    everyProduct
  },
  data() {
    return {
      orderList: [],
      productList: [],
      queryParam: {
        pageNo: 1,
        pageSize: 8,
        sortField: '',
        sortOrder: '',
        keywords: '',
        status: -1
      },
      proQueryParam: {
        client_Nu: '',
        memberId: 0,
        pageNo: 1,
        pageSize: 10
      },
      totalRows: 0,
      totalProRows: 0,
      memberInfo: {}
    }
  },
  computed: {
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    })
  },
  created() {
    this.initData()
    this.getUserInfo()
  },
  methods: {
    // 初始化
    initData() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('LLH.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.queryParam.userAccount = this.userInfo.userAccount
      getOrderList(this.queryParam).then(res => {
        this.orderList = res.data.rows
        this.totalRows = res.data.totalRows
      })

      this.getSellRec()

    },

    // 分页
    handleProCurrentChange(pageNo) {
      this.proQueryParam.pageNo = pageNo
      this.getSellRec()
    },

    // 分页大小操作
    handleProSizeChange(pageSize) {
      this.proQueryParam.pageNo = 1
      this.proQueryParam.pageSize = pageSize
      this.getSellRec()
    },

    // 获取业务推荐产品
    getSellRec() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('LLH.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.proQueryParam.client_Nu = this.userInfo.client_Nu || ''
      this.proQueryParam.memberId = this.userInfo.id
      getSellRecPorductList(this.proQueryParam).then(res => {
        if (res.success) {
          this.productList = res.data.rows || []
          this.totalProRows = res.data.totalRows
          this.productList.forEach(item => {
            transformMark(item.imgUrl + '?imageMogr2/thumbnail/800x').then(result => {
              item.imgUrl = result
            })
          })
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.$message.error(err)
      }).finally(() => {
        loading.close()
      })
    },

    // 获取用户信息
    getUserInfo() {
      GetMemberInfo()
        .then(res => {
          if (res.success) {
            this.memberInfo = res.data.member || {}
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },

    onSearch() {
      this.initData()
    },
    // 选择页码大小
    handleSizeChange(pageSize) {
      this.queryParam.pageSize = pageSize
      this.initData()
    },
    // 分页
    handleCurrentChange(pageNo) {
      this.queryParam.pageNo = pageNo
      this.initData()
    }
  }
}
</script>
<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: center;
  padding: 10px;
  margin-bottom: 40px;
  background-color: #fff;
  ::v-deep .active {
    background-color: #ff0000 !important;
  }
}
.myorderBrand {
  width: 100%;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  .orderTitle {
    font-size: 14px;
    font-family: Arial, Arial-Regular;
    font-weight: 400;
    color: #999999;
    span:hover {
      color: #ff0000;
      text-decoration: underline;
    }
  }
}
.order {
  background-color: #fff;
  padding: 10px 0;
}
.myOrderTile {
  font-size: 16px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  text-align: left;
  color: #222222;
  margin-bottom: 20px;
  margin-top: 30px;
}
.order-container {
  .order-list {
    width: 100%;
    .order_listBox {
      display: flex;
      flex-wrap: wrap;
      font-size: 25px;
      .order_list_items {
        width: 578px;
        margin-bottom: 40px;
        margin-right: 40px;
        background: #ffffff;
        border: 1px solid #e9e9e9;
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.06);
        position: relative;
        &:nth-child(2n) {
          margin-right: 0 !important;
        }
      }
      .order_numer {
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        color: #222222;
        margin-top: 20px;
        margin-left: 21px;
      }
      .order_Time {
        margin-top: 24px;
        margin-left: 21px;
        .Time_TitleName,
        .Time_Title {
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #999999;
        }
        .Time_Title {
          color: #666666 !important;
        }
      }
      .order_contactPerson {
        margin-left: 21px;
        .contactPerson_Title,
        .contactPerson_Name {
          font-size: 14px;
          font-family: Arial, Arial-Regular;
          font-weight: 400;
          text-align: left;
          color: #999999;
        }
        .contactPerson_Name {
          color: #666666 !important;
        }
      }
      .order_emai {
        margin-left: 21px;
        padding-bottom: 20px;
        .emai_title,
        .emai_number {
          font-size: 14px;
          font-family: Arial, Arial-Regular;
          font-weight: 400;
          text-align: left;
          color: #999999;
        }
        .emai_number {
          color: #666666 !important;
        }
      }
      .orderDetails {
        width: 120px;
        height: 34px;
        background: #ff0000;
        position: absolute;
        right: 20px;
        bottom: 30px;
        font-size: 14px;
        font-family: Arial, Arial-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 34px;
        cursor: pointer;
      }
    }
    .pagination {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
      margin-top: 15px;
      background-color: #fff;
    }
  }
}
.exclusive {
  padding: 20px 0;
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #222222;
    // margin: 20px 0 0 0;
  }

  .pro-list {
    display: flex;
    flex-wrap: wrap;
    margin: 20px 0 0 0;

    .cell {
      width: 224px;
      margin: 0 20px 20px 0;
      &:nth-child(5n) {
        margin-right: 0;
      }
    }
  }
}

.pagination {
  display: flex;
  justify-content: center;
  padding: 10px;
}

:deep .el-pagination__total {
  margin: 0 20px;
}

.pagination2 {
  display: none;
}
</style>